module.exports = __webpack_public_path__ + "img/map.e88434ad.svg";